import { P } from "./constants";

export const fmt = n => n >= 1e6 ? `$${(n/1e6).toFixed(1)}M` : n >= 1000 ? `$${(n/1000).toFixed(0)}K` : `$${n}`;
export const ini = n => n.split(" ").map(w => w[0] || "").join("").slice(0,2).toUpperCase();
export const stColor = s => ({expected:P.bl,arrived:"#241C8A","checked-in":"#3127B8",departed:P.gy,ready:"#241C8A",retrieving:"#3127B8",incoming:P.bl,parked:"#241C8A",retrieve:"#3127B8"}[s] || P.gy);
